import React from 'react';
import ContentLoader from 'react-content-loader';

import { Medium, LargeUp } from 'components/MediaQuery';
import Theme from 'styles/theme';

import { DIMENSIONS } from './constants';

const Placeholder = props => (
  <div className="Placeholder">
    <Medium>
      <ContentLoader
        height={DIMENSIONS.TABLET_HEIGHT}
        width={DIMENSIONS.TABLET_WIDTH}
        primaryColor={Theme.get('colors-grey')}
        secondaryColor={Theme.get('colors-grey')}
        animate={false}
        {...props}
      >
        <rect width={DIMENSIONS.TABLET_WIDTH} height={DIMENSIONS.TABLET_HEIGHT} />
      </ContentLoader>
    </Medium>
    <LargeUp>
      <ContentLoader
        height={DIMENSIONS.DESKTOP_HEIGHT}
        width={DIMENSIONS.DESKTOP_WIDTH}
        primaryColor={Theme.get('colors-grey')}
        secondaryColor={Theme.get('colors-grey')}
        animate={false}
        {...props}
      >
        <rect width={DIMENSIONS.DESKTOP_WIDTH} height={DIMENSIONS.DESKTOP_HEIGHT} />
      </ContentLoader>
    </LargeUp>
  </div>
);

Placeholder.propTypes = {};

Placeholder.defaultProps = {};

export default Placeholder;
